import * as React from 'react';
import { useDispatch } from 'react-redux';

import { ZoomOutButton } from './ZoomOutButton';
import { closeOfferPreview } from '../../../../../common/actions/closeOfferPreview/closeOfferPreview';
import { TThunkDispatch } from '../../../../../common/types/redux';
import { useMapController } from '../../../../controller/useMapController';
import { useReloadHybridSearchAfterMapInteraction } from '../../hooks/useReloadHybridSearchAfterMapInteraction';
import { useTrackMapInteraction } from '../../utils/useTrackMapInteraction';

export const ZoomOutButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const controller = useMapController();
  const reloadHybridSearchAfterMapInteraction = useReloadHybridSearchAfterMapInteraction();
  const trackMapInteractions = useTrackMapInteraction();

  const handleZoomOut = React.useCallback(() => {
    dispatch(closeOfferPreview());

    const zoom = controller.getZoom();
    const [minZoom] = controller.getZoomRange();
    if (zoom <= minZoom) {
      return;
    }

    controller.zoomOut(() => reloadHybridSearchAfterMapInteraction({ mapSnapshot: controller.getSnapshot() }));
  }, [controller, dispatch, reloadHybridSearchAfterMapInteraction]);

  return <ZoomOutButton onZoomOut={handleZoomOut} onClick={trackMapInteractions} />;
};
